import styles from "./style.module.css";
import React, { useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// import dataContext from "../../../../context/dataContext";
import mainContext from "../../../context/mainContext";

const ExerciseRate = () => {
  // const user = useContext(dataContext);
  const { header } = useContext(mainContext);
  const { state } = useLocation();
  const [userClick, setUserClick] = useState(false)
  const [roundData, setRoundData] = useState({ newLPM: state.New_LPM ? state.New_LPM : state.LPM, round: state.roundExercise ? state.roundExercise : 0, clickedButton: state.ClickedButton, isJustRight: state.JustRight ? state.JustRight : false })

  const route = "/train-reading/question";
  const navigate = useNavigate();

  console.log("exerciseRate", state);
  console.log("newLpm", roundData.newLPM);

  useEffect(() => {
    header.setPageName("FINE-TUNING, How Does It Feel?")
    return () => header.setPageName("")
  }, [])

  useEffect(() => {
    console.log("🚀 ~ file: ExerciseRate.jsx:27 ~ useEffect ~ roundData:", roundData)
    roundData.round > 0 && userClick && startFunction();
  }, [roundData]);

  const objProp = {
    LPM_Pushup: state.LPM_Pushup,
    New_LPM: roundData.newLPM,
    JustRight: roundData.isJustRight,
    roundExercise: roundData.round,
    ClickedButton: roundData.clickedButton,
    fromPath: "train-reading/rate",
    formInfo: state.formInfo,
  };

  function choice(button) {
    setUserClick(true)
    if (button === "JR") {
      setRoundData(prev => ({ ...prev, isJustRight: true, round: prev.round + 1, clickedButton: [...prev.clickedButton, "JR"] }))
      // setIsJustRight(true);
      // setRound(round + 1 + state.roundExercise);
      // setClickedButton((clickedButton) => [...clickedButton, "JR"]);
    }

    if (state.ClickedButton.length === 0) {
      if (button === "TF") {
        setRoundData(prev => ({ ...prev, newLPM: prev.newLPM - 2, round: prev.round + 1, clickedButton: [...prev.clickedButton, "TF"] }))
        // setNewLPM(LPM_fromClock - 2);
        // setRound(round + 1 + state.roundExercise);
        // setClickedButton((clickedButton) => [...clickedButton, "TF"]);
      }
      if (button === "TS") {
        setRoundData(prev => ({ ...prev, newLPM: prev.newLPM + 2, round: prev.round + 1, clickedButton: [...prev.clickedButton, "TS"] }))
        // setNewLPM(LPM_fromClock + 2);
        // setRound(round + 1 + state.roundExercise);
        // setClickedButton((clickedButton) => [...clickedButton, "TS"]);
      }
    }
    if (state.ClickedButton.length > 0) {
      if (button === "TF" &&
        state.ClickedButton[state.ClickedButton.length - 1] === "TF") {
        setRoundData(prev => ({ ...prev, newLPM: prev.newLPM - 2, round: prev.round + 1, clickedButton: [...prev.clickedButton, "TF"] }))
        // setNewLPM(newLPM - 2);
        // setRound(round + 1 + state.roundExercise);
        // setClickedButton((clickedButton) => [...clickedButton, "TF"]);
      }
      if (
        button === "TS" &&
        state.ClickedButton[state.ClickedButton.length - 1] === "TS") {
        setRoundData(prev => ({ ...prev, newLPM: prev.newLPM + 2, round: prev.round + 1, clickedButton: [...prev.clickedButton, "TS"] }))
        // setNewLPM(newLPM + 2);
        // setRound(round + 1 + state.roundExercise);
        // setClickedButton((clickedButton) => [...clickedButton, "TS"]);
      }

      if (
        button === "TS" &&
        state.ClickedButton[state.ClickedButton.length - 1] === "TF") {
        setRoundData(prev => ({ ...prev, newLPM: prev.newLPM + 1, round: prev.round + 1, clickedButton: [...prev.clickedButton, "TS"] }))
        // setNewLPM(newLPM + 1);
        // setRound(round + 1 + state.roundExercise);
        // setClickedButton((clickedButton) => [...clickedButton, "TS"]);
      }

      if (
        button === "TF" &&
        state.ClickedButton[state.ClickedButton.length - 1] === "TS") {
        setRoundData(prev => ({ ...prev, newLPM: prev.newLPM - 1, round: prev.round + 1, clickedButton: [...prev.clickedButton, "TF"] }))
        // setNewLPM(newLPM - 1);
        // setRound(round + 1 + state.roundExercise);
        // setClickedButton((clickedButton) => [...clickedButton, "TF"]);
      }
    }
  }

  const startFunction = () => navigate(route, { state: { ...state, ...objProp } });

  return (
    <div className={styles.container}>
      <div className={` ${styles.answers} two-colored-div`}  >
        {/* <p>How Does It Feel?</p> */}
        <button name="just right" type={"button"} onClick={() => choice("JR")}> JUST RIGHT</button>
        <button name="Too Fast" type={"button"} onClick={() => choice("TF")} >  TOO FAST</button>
        <button name="Too Slow" type={"button"} onClick={() => choice("TS")}  > TOO SLOW </button>
      </div>
    </div>
  );
};

export default ExerciseRate;
